import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import { AddinSidePane } from 'owa-calendar-addins';
import FullComposeExpressionPane from './FullComposeExpressionPane';
import FullComposeRoomListPane from './FullComposeRoomListPane';
import FullComposeTrackingPane from './FullComposeTrackingPane';
import FullComposeAccCheckerPane from './FullComposeAccCheckerPane';

export interface FullComposeSidePaneProps {
    formId: string | null;
}

const FullComposeSidePane: React.FunctionComponent<FullComposeSidePaneProps> = props => {
    const { formId } = props;

    const fullComposeViewState = getFullComposeViewState(formId);

    if (!fullComposeViewState.currentSidePaneType) {
        return null;
    }

    switch (fullComposeViewState.currentSidePaneType) {
        case SidePaneType.Addins:
            return <AddinSidePane />;
        case SidePaneType.EmojiPicker:
            return <FullComposeExpressionPane formId={formId} />;
        case SidePaneType.RoomList:
            return <FullComposeRoomListPane formId={formId} />;
        case SidePaneType.Tracking:
            return <FullComposeTrackingPane formId={formId} />;
        case SidePaneType.AccessibilityChecker:
            return <FullComposeAccCheckerPane formId={formId} />;
    }

    return null;
};

export default observer(FullComposeSidePane);
